module.exports = __webpack_public_path__ + "img/39_57.6c572730.png";